<template src="./MenuTitle.html"> </template>

<script>
export default {
    name: 'MenuTitle',
    props: {
        text: {
            required: true,
            type: String,
            },
    },
}
</script>

<style lang="scss" src="./MenuTitle.scss"> </style>